export const CHART_KPIS = ['showannualvariation', 'showtotal']

export function getCardKpis(card, data) {
  return card.kpis.map(kpi => {
    //Aqui hay que "calcularlo en funcion del kpi y los datos"
    let fakeValue = data.values[0][1]
    return {
      id: kpi,
      value: fakeValue,
    }
  })
}
